import { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
const helmetContext = {};
const SITE_URL = 'https://aurealestate.in';

// The canonical must be an absolute URL of the page itself. It's built from the current path (like the one
// server/index.js puts in the HTML) rather than props.link, which held relative and copy-pasted values.
function canonicalFor(pathname) {
    const path = pathname.replace(/\/+$/, '');
    return SITE_URL + (path || '/');
}

function Metatag(props){
    const { pathname } = useLocation();

    // server/index.js already put a canonical in the HTML; drop it so the page has only the one Helmet manages
    useEffect(() => {
        document.querySelectorAll('link[rel="canonical"]:not([data-rh])').forEach((el) => el.remove());
    }, []);

    return (
        <HelmetProvider context={helmetContext}>
        <div className="application">
            <Helmet>
                <meta charSet="utf-8" />
                <title>{props.title}</title>
                <meta name="description" content={props.description} />
                <meta name="keywords" content={props?.keyword || ''} />
                <link rel="canonical" href={canonicalFor(pathname)} />
            </Helmet>
        </div>
        </HelmetProvider>
    );
  }
export default Metatag
